<template>
  <v-dialog :value="isOpen" max-width="400">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ text }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="$emit('onClose')">
          {{ $t('cancel') }}
        </v-btn>

        <v-btn
          text
          @click="
            $store.commit('toggleNavigationDrawer', false);
            $store.dispatch('lifecycle/resetApp');
            $store.dispatch('profile/logout');
          "
        >
          {{ $t('ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ResetAppDialog',
  props: ['isOpen', 'title', 'text'],
};
</script>
